import React from "react";
//#region types
import { InvoiceGeneralSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DisplayProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { GroupSectionInline, ReadOnlyVerticalFormField, TextDisplay } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const InvoiceGeneralSection: React.FC<InvoiceGeneralSectionProps> = (props) => {
  const { invoice, values } = props;

  return (
    <GroupSectionInline
      key={`ReadOnlyFormControlLayout-invoiceGeneral`}
      label={TranslationKeys.Common.General}
      icon={IconDefinitionConstants.WInfo}
    >
      {!!values.customerName && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField<DisplayProps>
            Component={TextDisplay}
            value={values.customerName}
            label={TranslationKeys.Invoice.Customer}
            href={UrlHelper.formatPath(`/Customer/${invoice.customerId}`)}
          />
        </Grid>
      )}
      {!!values.customerOrgNr && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.customerOrgNr}
            label={TranslationKeys.Common.OrgNo}
          />
        </Grid>
      )}
      {!!values.referencePerson && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.referencePerson}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CustomerReference)}
          />
        </Grid>
      )}
      {!!values.contactPerson && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.contactPerson}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.OurReference)}
          />
        </Grid>
      )}
      {!!values.owner && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.owner}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Owner)}
          />
        </Grid>
      )}
      {!!values.recurringDescription && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.recurringDescription}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Description)}
          />
        </Grid>
      )}
      {!!values.serialNumber && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.serialNumber}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceNumber)}
          />
        </Grid>
      )}
    </GroupSectionInline>
  );
};

export default InvoiceGeneralSection;
